type MembershipFeePixData = {
  qr_code?: string | null;
  order_id?: string | null;
  qrCode?: string | null;
  id?: string | null;
};

/**
 * Lê o QR do Pix e o pedido a acompanhar na resposta de `POST /v2/Quotes/{id}/membership_fee`.
 * A API devolve `qr_code` / `order_id`; a tela lia `qrCode` / `id`, mostrava um QR de "undefined" e abria o
 * acompanhamento em `/Orders/undefined/status_update`, que nunca confirma o pagamento.
 */
export function readMembershipFeePix(data: unknown): { qrCode: string; orderId: string } | null {
  if (!data || typeof data !== 'object') return null;
  const pix = data as MembershipFeePixData;
  const qrCode = pix.qr_code ?? pix.qrCode;
  const orderId = pix.order_id ?? pix.id;
  if (!qrCode || !orderId) return null;
  return { qrCode, orderId };
}
